import React, { useEffect, useRef, useState } from "react";

const Testimonial = () => {
    const wrapperRef = useRef(null);
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        const wrapper = wrapperRef.current;
        const cards = Array.from(wrapper.children); // Liste des témoignages

        setTestimonials(
            cards.map((card, index) => ({
                element: card,
                rotation: (index % 2 === 0 ? -15 : 15), // Alternance rotation par défaut
                position: 100 * index, // Position initiale empilée
            }))
        );

        let scrollPosition = 0;

        const handleScroll = () => {
            scrollPosition += 2; // Ajustez la vitesse ici
            if (scrollPosition > cards.length * 100) {
                scrollPosition = 0; // Réinitialisation du défilement
            }

            const updatedTestimonials = cards.map((card, index) => {
                const distanceFromCenter = Math.abs(scrollPosition - index * 100);
                const alignedRotation = distanceFromCenter < 50 ? 0 : (index % 2 === 0 ? -15 : 15);
                const alignmentOffset = distanceFromCenter < 50 ? 0 : distanceFromCenter / 5;

                return {
                    element: card,
                    rotation: alignedRotation,
                    position: index * 100 - scrollPosition + alignmentOffset,
                };
            });

            setTestimonials(updatedTestimonials);
        };

        const interval = setInterval(handleScroll, 30);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        // Appliquer les styles aux témoignages
        testimonials.forEach(({ element, rotation, position }) => {
            element.style.transform = `translateY(${position}px) rotate(${rotation}deg)`;
        });
    }, [testimonials]);
    return (
        <>
            <div className="container">
                <div className="col-12">
                    <div className="content">

                        <h2 className="fw-bold">Ce qu’ils disent de nous</h2>
                        <p className="text-center">
                            Découvrez les avis et témoignages de ceux qui nous font déjà confiance.
                        </p>
                    </div>
                </div>
                <div className="testimonials-container">
                    <div className="testimonials-grid" ref={wrapperRef}>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Doumbia Moussa ( Client ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"Je reçois des notifications dès que mes vêtements sont prêts. <br /> Plus besoin de téléphoner ou de me déplacer inutilement."</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Yao Herver (Propriétaire de pressing) ( Client ) </h5>
                                        <div className="rating">★★★★</div>
                                    </div>
                                </div>
                                <p>"J’ai vu une nette augmentation de ma clientèle grâce aux fonctionnalités comme les notifications et la réservation en ligne."</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Kouakou Grâce ( Cliente ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"J’adore le service de livraison intégré à l’application. Mes vêtements me sont livrés directement à domicile."</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Sery Tapé  (Propriétaire de pressing) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"Les clients apprécient tellement l’expérience que j’ai maintenant beaucoup plus de retours positifs sur mon service."</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">N'bia Marc ( client ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"Moi, je ne dépose plus mes vêtements dans un pressing qui n’utilise pas Pressing 360. C’est tellement plus pratique et rassurant !"</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Issac Jean ( Propriétaire de pressing ) </h5>
                                        <div className="rating">★★★★</div>
                                    </div>
                                </div>
                                <p>"C’est grâce à Pressing 360 que je peux maintenant facilement suivre les performances de mon personnel et repérer les points qu’ils réalisent réellemnt."</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Konan Adeline ( Propriétaire de pressing ) </h5>
                                        <div className="rating">★★★★</div>
                                    </div>
                                </div>
                                <p>"Les clients reçoivent directement les images de leurs vêtements au dépôt. Fini les discussions sur 'ce n’est pas mon vêtement'. Cela évite vraiment les bavardages inutiles !"</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Gnahoré Jean-Marc ( Client ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"Pressing 360 ou rien"</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Niplé Roseline ( Propriétaire de pressing ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"Un grand merci au service support de Pressing 360. Ils sont vraiment très réactifs et toujours prêts à aider !"</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Lourougon Yves ( Client ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"Pour me remercier de ma fidélité, je reçois souvent des codes promos. !"</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0"> Lavoisier laRoche  ( Propriétaire de pressing ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"En tout cas, le logiciel Pressing 360 est vraiment bien pensé. Il est indispensable pour les pressings et laveries !"</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Koukoué Paco (  Propriétaire de pressing ) </h5>
                                        <div className="rating">★★★★★</div>
                                    </div>
                                </div>
                                <p>"Ça m’a paru compliqué au début, mais après seulement 2 séances de formation avec l’équipe Pressing 360, je suis devenu un dur !"</p>
                            </div>
                        </div>
                        <div className="card testimonial-card">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb" className="avatar" alt="Jane Doe" />
                                    <div className="ms-3">
                                        <h5 className="mb-0">Ouattara Ali ( Client ) </h5>
                                        <div className="rating">★★★★</div>
                                    </div>
                                </div>
                                <p>"C’est super, Pressing 360 ! Je n’ai plus peur que mes vêtements se perdent dans le pressing. "</p>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default Testimonial